<template>
	<div>
		<Layout :navFixed="false" :transparent="false" :invert="true">
			<div class="container">
				<div class="row row-xs">
					<div class="col-12 col-md-6" v-for="item in items" :key="item.id">
						<ProductItem :item="item" />
					</div>
				</div>
				<div class="mt-4 p-4">
					<FoodTruckBanner />
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import Layout from '@/components/Layout'
import ProductItem from '@/components/ProductItem'
import FoodTruckBanner from '@/components/FoodTruckBanner'

export default {
	name: 'Home',
	components: {
		Layout,
		ProductItem,
		FoodTruckBanner,
	},
	metaInfo: {
		title: 'Campers',
	},
	data() {
		return {
			items: [],
		}
	},
	beforeMount() {
		this.load()
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($category: String, $status: String) {
							products(category: $category, status: $status) {
								data {
									id
									name
									slug
									salable
									price
									image {
										id
										type
										filename
										url
										urlThumb
									}
									featured
								}
							}
						}
					`,
					variables: {
						category: 'campers',
						status: 'ACTIVE',
					},
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.items = data.products.data
				})
				.catch(() => {})
		},
	},
}
</script>

<style scoped></style>
